import { Component, OnInit, Output } from '@angular/core';
import { FilterSettingsModel, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Subject, switchMap, tap } from 'rxjs';
import { LotacaoAtribuicaoDto } from 'src/app/dtos/lotacoes-atribuicoes/lotacao-atribuicao-dto';
import { LotacaoAtribuicaoService } from 'src/app/servicos/lotacao-atribuicao.service';
import { PacienteService } from 'src/app/servicos/paciente.service';

@Component({
  selector: 'app-paciente-agente-lista',
  templateUrl: './paciente-agente-lista.component.html',
  styleUrls: ['./paciente-agente-lista.component.less']
})
export class PacienteAgenteListaComponent implements OnInit {

  lotacaoAtribuicaoTexto: string = '';

  @Output()
  lotacaoAtribuicaoId: Subject<number> = new Subject<number>();

  registros: Object | null = null;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }
  
  constructor(private pacienteService: PacienteService,
      private lotacaoAtribuicaoService: LotacaoAtribuicaoService) { }

  ngOnInit(): void {

  }

  carregar(lotacaoId: number) {
    this.lotacaoAtribuicaoService.consultarLotacaoAtribuicao(lotacaoId)
    .pipe(
      tap((lotacao => {
        this.lotacaoAtribuicaoTexto = 
          lotacao.estabelecimentoNomeFantasia + " - " + lotacao.cargoNome + " / " + lotacao.cargoCbo;
      })),
      switchMap(() => this.pacienteService.listarAgentes(lotacaoId))
    )
    .subscribe((agentes) => {
      this.registros = agentes;
    });
  }

  lotacaoSelecionada(lotacao: LotacaoAtribuicaoDto) {
    this.lotacaoAtribuicaoId.next(lotacao.sId);

    this.lotacaoAtribuicaoTexto = 
      lotacao.estabelecimentoNomeFantasia + " - " + lotacao.cargoNome + " / " + lotacao.cargoCbo;

    this.carregar(lotacao.sId);
  }

}
